import React, { createContext, useContext, ReactNode } from 'react';
import { useFavorites, UseFavoritesReturn } from '../hooks/useFavorites';

interface FavoritesProviderProps {
  children: ReactNode;
}

const FavoritesContext = createContext<UseFavoritesReturn | undefined>(undefined);

export const FavoritesProvider: React.FC<FavoritesProviderProps> = ({ children }) => {
  const favoritesData = useFavorites();
  

  return (
    <FavoritesContext.Provider value={favoritesData}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavoritesContext = () => {
  const context = useContext(FavoritesContext);
  if (context === undefined) {
    throw new Error('useFavoritesContext must be used within a FavoritesProvider');
  }
  return context;
};